import React from "react";
import { useForm } from "react-hook-form";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { applyStepState } from "../../recoil/pageStep";
import { isPracticeState, practiceVideoSrcState, trialState } from "../../recoil/record";
import SurveyContainer from "../atoms/layout/SurveyContainer";
import { ApplyStep } from "./ApplyRouter";
import useExamActions from "../../api/hooks/exam";
import { useSearchParams } from "react-router-dom";

const VideoConfirm = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const examActions = useExamActions();
  const practiceVideoSrc = useRecoilValue(practiceVideoSrcState);
  const setIsPractice = useSetRecoilState(isPracticeState);
  const setApplyStep = useSetRecoilState(applyStepState);
  const setTrial = useSetRecoilState(trialState);
  const { register, handleSubmit } = useForm();

  const onSubmit = async (data) => {
    if (!data.check1 || !data.check2 || !data.check3 || !data.check4) {
      alert("녹화된 답변영상을 보고 아래 사항을 모두 확인(체크)해 주세요.");
      return;
    }

    setIsPractice(false);
    const uid = searchParams.get("uid")
    const res = await examActions.setPracticeDone(uid);
    if (res.status === 200) {
      setApplyStep((old) => old + 1);  
    }
  };

  return (
    <SurveyContainer title="영어 말하기 평가">
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="base-sec-sec video-confirm-sec">
          <div className="page-title text-align-center">
            <p>연습평가</p>
            <p style={{fontSize: "14px"}}>연습평가는 준비용으로 응시 횟수에 제한이 업고, 실제 평가에 반영되지 않습니다.</p>
          </div>
          <div className="qna">
            <div className="half-area">
              <div className="black-box text-align-center">
                <p>녹화된 영상 확인</p>
              </div>
              <div className="video-confirm-box">
                <div className="video-confirm-img-box text-align-center">
                  <div className="video-confirm-img video-confirm-img1"></div>
                  <div className="video-confirm-img video-confirm-img2"></div>
                  <div className="video-confirm-img video-confirm-img3"></div>
                </div>
                <div className="check-title-text">
                  <p>
                    녹화된 답변영상을 보고 아래 사항을 모두 확인(체크)해 주세요.
                  </p>
                </div>
                <div className="video-confirm-check-box">
                  <div className="video-confirm-check">
                    <label className="check-container ">
                      <input type="checkbox" {...register("check1")} />
                      <span className="checkmark"></span>
                      <span>영상에서 본인 얼굴이 잘 보입니다.</span>
                    </label>
                  </div>
                  <div className="video-confirm-check">
                    <label className="check-container ">
                      <input type="checkbox" {...register("check2")} />
                      <span className="checkmark"></span>
                      <span>목소리가 분명하게 잘 나옵니다.</span>
                    </label>
                  </div>
                  <div className="video-confirm-check">
                    <label className="check-container ">
                      <input type="checkbox" {...register("check3")} />
                      <span className="checkmark"></span>
                      <span>
                        원서접수 시 제출한 본인사진과 동영상의 본인이
                        일치합니다.
                      </span>
                    </label>
                  </div>
                  <div className="video-confirm-check">
                    <label className="check-container ">
                      <input type="checkbox" {...register("check4")} />
                      <span className="checkmark"></span>
                      <span>
                        본인 이외의 다른사람(목소리 포함)이 동영상에 나오지
                        않습니다.
                      </span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div className="half-area">
              <div className="black-box text-align-center">
                <p>답변</p>
              </div>
              <div>
                {/* <div className="answer-time text-align-center">
                  <p className="time">
                    준비시간 <b>0:15</b>
                  </p>
                  <p className="time">
                    최소 답변시간 <b>0:30</b>
                  </p>
                  <p className="time">
                    최대 답변시간 <b>3:00</b>
                  </p>
                </div>
                <div className="now-step flex">
                  <div>
                    <p className="time-step-title">준비시간</p>
                  </div>
                  <div>
                    <p>0:15</p>
                  </div>
                  <div>
                    <button className="start-step-btn" disabled>
                      답변시작
                    </button>
                  </div>
                </div> */}
                <div className="camera-screen">
                  <video autoPlay controls height="100%" width="100%" src={practiceVideoSrc} />
                </div>
                <div></div>
              </div>
            </div>
          </div>
          <div className="base-sec-bottom text-align-center">
            <button
              type="button"
              className="bottombtn bottombtn-w"
              onClick={() => setApplyStep((old) => old - 1)}
            >
              다시연습
            </button>
            <button
              className="bottombtn bottombtn-b"
              type="submit"
            >
              실제평가 시작
            </button>
          </div>
        </div>
      </form>
    </SurveyContainer>
  );
};

export default VideoConfirm;
